import { initClickTracker } from './core/click-tracker'

const tracker = initClickTracker({
    endpoint: baseURL + '/click-events'
});

require('./regular/index');
require('./modules/index');


const phone = document.querySelector('.hidden-phone');

if (phone) {
    phone.addEventListener('mouseover', function() {
        this.style.opacity = '0';
        setTimeout(() => {
            this.textContent = this.dataset.real;
            this.style.opacity = '1';
        }, 0);
    });

    phone.addEventListener('mouseout', function() {
        this.style.opacity = '0';
        setTimeout(() => {
            this.textContent = this.dataset.vanity;
            this.style.opacity = '1';
        }, 0);
    });
}